// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ao-4";
export var closeButton = "_ao-6";
export var dismissButton = "_ao-3";
export var editImageWithAiContainer = "_ao-8";
export var imageUploadWrapper = "_ao-7";
export var misspelledWord = "_ao-5";
export var spellCheckContainer = "_ao-2";
export var spin = "_ao-1";
export var spinning = "_ao-0";